<template>
  <el-dialog :visible.sync="visible" title="供应商账号设置" :close-on-click-modal="false"
             :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
             label-width="120px">
      <el-form-item prop="companyId" label="供应商：">
        <company v-model="dataForm.companyId" ></company>
      </el-form-item>
      <el-form-item prop="mobile" :label="$t('user.mobile')+'：'">
        <el-input v-model="dataForm.mobile" size="mini" :placeholder="$t('user.mobile')"
                  ></el-input>
      </el-form-item>
      <el-form-item label="默认密码：" v-if="!$c.str2bool(dataForm.id)">
        <span>123456</span>
      </el-form-item>
      <el-form-item prop="realName" :label="$t('user.realName')+'：'">
        <el-input v-model="dataForm.realName" size="mini" :placeholder="$t('user.realName')"></el-input>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import { isEmail, isMobile } from '@/utils/validate'

export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        username: '',
        deptId: '0',
        deptName: '',
        realName: '',
        gender: 0,
        email: '',
        mobile: '',
        status: 1,
        companyId: ''
      }
    }
  },
  computed: {
    dataRule () {
      var validateMobile = (rule, value, callback) => {
        if (!isMobile(value)) {
          return callback(new Error(this.$t('validate.format', { 'attr': this.$t('user.mobile') })))
        }
        callback()
      }
      return {
        username: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        realName: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        roleIdList: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
        ],
        mobile: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
          { validator: validateMobile, trigger: 'change' }
        ],
        companyId: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' },
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/user/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },
    // 所属部门树, 选中
    deptListTreeCurrentChangeHandle (data, node) {
      this.dataForm.deptId = data.id
      this.dataForm.deptName = data.name
      this.deptListVisible = false
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        let postForm = this.$clone(this.dataForm)
        postForm.username = postForm.mobile
        let url = `/sys/user/company/open`
        if (postForm.id) {
          url = `/sys/user`
        }
        this.$api[postForm.id ? 'put' : 'post'](url, postForm).then(res => {
          this.$c.success(this.$t('prompt.success')).then(() => {
            this.visible = false
            this.$emit('refreshDataList')
          })
        })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>

<style lang="scss">
.mod-sys__user {
  .dept-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }

  .role-list {
    .el-select {
      width: 100%;
    }
  }
}
</style>
